export let OneDriveText = "TgscH";
export default {OneDriveText};